import React from 'react';
import { Loader2, X } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Card } from '../../../ui/card';
import { Textarea } from '../../../ui/textarea';

const MemberRemoveModal = ({
  show,
  memberToRemove,
  removeReason,
  setRemoveReason,
  removing,
  handleRemoveMember,
  onClose,
}) => {
  if (!show || !memberToRemove) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <Card className="w-full max-w-md border-[#2a2a32] bg-[#1e1e24] p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-white">Remove dad</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="mb-3 text-sm text-gray-400">
          Removing <span className="font-medium text-white">{memberToRemove.name}</span>. This
          will set their status to former.
        </p>
        <div className="mb-4">
          <label className="mb-2 block text-sm text-gray-400">Reason *</label>
          <Textarea
            placeholder="Enter reason for removal..."
            value={removeReason}
            onChange={(event) => setRemoveReason(event.target.value)}
            className="min-h-[80px] border-[#2a2a32] bg-[#16161a] text-white"
            rows={3}
          />
        </div>
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-[#2a2a32] text-white hover:bg-[#16161a]"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveMember}
            disabled={removing || !removeReason.trim()}
            className="flex-1 bg-aqua text-charcoal hover:bg-aqua-dark"
          >
            {removing ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Confirm'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default MemberRemoveModal;
